/* ============================================================
   BONHEUR - Contador de la dedicatoria

   Progresivo: el limite real lo impone el atributo maxlength del
   input, que funciona sin JavaScript. Esto solo agrega el contador
   visible, que es lo que evita que el cliente escriba de mas y se
   lleve la sorpresa al recibir la torta.
   ============================================================ */
(function () {
  function conectar(caja) {
    if (caja.dataset.bhListo === '1') return;
    var input = caja.querySelector('[data-bh-max]');
    var salida = caja.querySelector('[data-bh-contador]');
    if (!input || !salida) return;

    caja.dataset.bhListo = '1';
    var max = parseInt(input.getAttribute('data-bh-max'), 10) || 0;

    function pintar() {
      var n = input.value.length;
      salida.textContent = n + ' / ' + max;
      if (max && n >= max) {
        salida.setAttribute('data-bh-lleno', '');
      } else {
        salida.removeAttribute('data-bh-lleno');
      }
    }

    input.addEventListener('input', pintar);
    pintar();
  }

  function iniciar() {
    document.querySelectorAll('[data-bh-dedicatoria]').forEach(conectar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', iniciar);
  document.addEventListener('shopify:block:select', iniciar);
})();
